export function trackDisplayName(name: string | null | undefined): string { const s = (name ?? '').trim(); return s.replace(/\.[A-Za-z0-9]{1,5}$/, '') || s }
